var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF3E3A;}\r\n\t.st1{fill:#CC3245;}\r\n\t.st2{fill:#373E9F;}\r\n\t.st3{fill:#340D66;}\r\n\t.st4{fill:#FFE7B5;}\r\n\t.st5{fill:#FFD06A;}\r\n\t.st6{fill:#FF9A27;}\r\n\t.st7{fill:#FFB820;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.4,3.6l-2.8-2.8L14.4,4l2.3,6L20.4,3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.4,3.6l-5.1,5.1L20,9.6l3.2-3.2L20.4,3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2.3,18.6l-1.5,4.6l4.9-3.1L2.3,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M0.8,23.2l4.6-1.5l-0.6-2.5L0.8,23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9,16.8L3.5,15l-1.2,3.6l1.6,1.6L9,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M3.9,20.1l1.6,1.6L9,20.5l-0.9-4.6L3.9,20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M6.3,17.7L9,20.5L20,9.6l-2.8-2.8l-7.3,3.6L6.3,17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M3.5,15L14.4,4l2.8,2.8L6.3,17.7L3.5,15z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.7f0be3f879d2ccb73e550a23c31cd650.svg";
export { ForwardRef as ReactComponent };